import React from "react";

import AmountInvestedResult from "../AmountInvestedResult";

const AmountInvestedTabContent = () => {
  return <AmountInvestedResult className="AmountInvestedTabContent" />;
};

export default AmountInvestedTabContent;
